import { useLayoutEffect, useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { createApplicationData } from 'core-components/sitebuilder/models/IApplication'
import { selectAppId } from 'core-components/sitebuilder/store/selectors/selectAppId'
import { selectAppOwnerId } from 'core-components/sitebuilder/store/selectors/selectAppOwnerId'
import { setApp } from 'core-components/sitebuilder/store/siteBuilderSlice'
import {
  getAppId,
  getAppOwnerId,
  initGlobalApplicationData,
} from 'src/core/classes/helpers/getAppId'
import { setApp as setCoreApp } from 'src/core/store/appSlice'

export const useInitApplication = () => {
  const dispatch = useDispatch()
  const id = useSelector(selectAppId)
  const ownerId = useSelector(selectAppOwnerId)

  const newApp = useMemo(() => {
    return createApplicationData({
      id: getAppId(),
      ownerId: getAppOwnerId(),
    })
  }, [])

  useLayoutEffect(() => {
    initGlobalApplicationData(newApp)
    dispatch(setCoreApp(newApp))
    // TODO: MOVE
    dispatch(setApp(newApp))
  }, [dispatch, newApp])

  return { id, ownerId }
}
